<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Dense -->
@if (layout === 'dense') {
    <dense-layout></dense-layout>
}